import { render, staticRenderFns } from "./overview-cell-text.vue?vue&type=template&id=40213e0a&scoped=true"
import script from "./overview-cell-text.vue?vue&type=script&lang=ts"
export * from "./overview-cell-text.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40213e0a",
  null
  
)

export default component.exports